import React, { Component } from "react";
import { observer } from "mobx-react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";

import QuizObjectTextField from "./Fields/QuizObjectTextField";

import QuizObjectChunks from "./Chunks";
import QuizObjectFacts from "./Facts";
import QuizObjectLists from "./Lists";
import QuizObjectTables from "./Tables";
import QuizObjectCardTables from "../../../Component/CardTablesEditor";

import CardStatus from "./CardStatus";
import StickyHeader from "./StickyHeader";

import { QuizObject } from "../../../../../store/modquiz/quiz_objects/quiz-object";

import { AreYouSure } from "../../../Component/AreYouSure";
import { SubmitSpinningButton } from "../../../Component/SubmitSpinningButton";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

interface MyProps {
    saveObject: (
        event?:
            | React.MouseEvent<Element, MouseEvent>
            | React.KeyboardEvent<Element>
    ) => void;
    deleteObject: (
        event?:
            | React.MouseEvent<Element, MouseEvent>
            | React.KeyboardEvent<Element>
    ) => void;
    quiz_object: QuizObject;
    handleTitleChange: (
        ev?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    handleDefinitionChange: (
        ev?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    handleNotesChange: (
        ev?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    addList: (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    addTable: (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    addFact: (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    addCardTable: (
        ev?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
    quizThisCard: (
        ev?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
    setCardTables: Function;
    setTables: Function;
    deleting: boolean;
    saving: boolean;
    error: boolean;
    errorTitle: string;
    errorMessage: string;
    deleteText: string;
    saveText: string;
    subjectHashKey: string;
}

class FullObjectPane extends Component<MyProps, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            showHelp: false,
            loadingSubjects: false,
            subtitle: "subtitle",
            helpFieldName: "notes",
            helpID: undefined
        };

        this.blurField = this.blurField.bind(this);
        this.focusField = this.focusField.bind(this);
    }

    errorRow() {
        if (!this.props.error) {
            return <div></div>;
        }
        return (
            <div className="row">
                <div className="col-lg-10 offset-1">
                    <Alert severity="warning">
                        <AlertTitle>{this.props.errorTitle}</AlertTitle>
                        {this.props.errorMessage}
                    </Alert>
                </div>
            </div>
        );
    }

    blurField() {
        this.setState({
            showHelp: false
        });
    }

    focusField(fieldName: string, id?: string, iterator?: string) {
        this.setState({
            showHelp: true,
            helpFieldName: fieldName,
            helpID: id
        });
    }

    onKeyUp(ev: React.KeyboardEvent<HTMLInputElement>) {
        console.log(ev.key);
        if (ev.key == "ArrowDown") {
            console.log("Arrow Down pushed");
        }
        console.log(ev.currentTarget);

        console.log("Title Key UP");
    }

    render() {
        let help = <></>;
        let questions = <></>;
        let prompt =
            "By adding a definition, you will generate questions like:";
        if (this.state.helpFieldName == "definition") {
            prompt = "";
            questions = (
                <>
                    <div>
                        Q: What is the definition of{" "}
                        {this.props.quiz_object.title}?
                    </div>
                    <br />
                    <div>A: {this.props.quiz_object.definition}</div>
                    <hr />
                    <div>
                        Q: Which card has the definition of{" "}
                        {this.props.quiz_object.definition}?
                    </div>
                    <br />
                    <div>A: {this.props.quiz_object.title}</div>
                </>
            );
        }

        if (this.state.helpFieldName == "chunk") {
            prompt = "This field will not generate any questions.";
            questions = <></>;
        }

        if (this.state.helpFieldName == "notes") {
            prompt = "This field will not generate any questions.";
            questions = <></>;
        }

        if (this.state.helpFieldName == "fact") {
            prompt = "By adding this fact, you will generate a question like:";

            questions = (
                <>
                    <div>
                        Q: What is the{" "}
                        {this.props.quiz_object.facts[this.state.helpID].name}{" "}
                        of {this.props.quiz_object.title}?
                    </div>
                    <br />
                    <div>
                        A:{" "}
                        {this.props.quiz_object.facts[this.state.helpID].value}
                    </div>
                </>
            );
        }

        if (this.state.helpFieldName == "list") {
        }

        if (this.state.helpFieldName == "table") {
            let prompt = "This table cell will generate a question like:";

            questions = (
                <>
                    <div>
                        Q: What is the{" "}
                        {this.props.quiz_object.facts[this.state.helpID].name}{" "}
                        of {this.props.quiz_object.title}?
                    </div>
                    <br />
                    <div>
                        A:{" "}
                        {this.props.quiz_object.facts[this.state.helpID].value}
                    </div>
                </>
            );
        }

        // Turn this on to enable help;
        if (this.state.showHelp) {
            help = (
                <div>
                    <h1>Help</h1>
                    <hr />
                    <p>{prompt}</p>
                    <br />
                    {questions}
                </div>
            );
        }

        let stickyHeader = (
            <StickyHeader>
                <div className="row CardStats">
                    <div className="col-lg-5 offset-1">
                        <ButtonGroup className="separated" variant="text">
                            <Button onClick={this.props.addList}>+ List</Button>
                            <Button onClick={this.props.addCardTable}>
                                + Card Table
                            </Button>
                            <Button onClick={this.props.addTable}>
                                + Table
                            </Button>
                            <Button onClick={this.props.addFact}>+ Fact</Button>
                            <Button onClick={this.props.quizThisCard}>
                                Quiz this Card
                            </Button>
                        </ButtonGroup>
                    </div>
                    <div className="col-lg-3 pull-right">
                        <SubmitSpinningButton
                            showSpinner={this.props.saving}
                            onClick={this.props.saveObject}
                            error={this.props.error}
                            text={this.props.saveText}
                            variant="text"
                        />

                        <AreYouSure
                            title="Delete?"
                            text="Are you sure you want to delete this object?  This cannot be undone."
                            onClick={this.props.deleteObject}
                        >
                            <SubmitSpinningButton
                                className="btn-outline-danger"
                                showSpinner={this.props.deleting}
                                error={this.props.error}
                                text={this.props.deleteText}
                                variant="text"
                            />
                        </AreYouSure>
                    </div>
                </div>
                <CardStatus status={this.props.quiz_object.saveStatus} />
                {this.errorRow()}
            </StickyHeader>
        );

        return (
            <div className="QuizObjectEditor">
                {this.props.quiz_object.editable ? stickyHeader : <div></div>}
                <div className="row quiz-object-editor">
                    <div className="col-lg-8 offset-1">
                        <br />
                        <FormGroup className="text-field">
                            <TextField
                                id="title"
                                onChange={this.props.handleTitleChange}
                                value={this.props.quiz_object.title}
                                className="form-control"
                                classes={{
                                    root: "textfield-heading-1 field-title"
                                }}
                                label="Title"
                                onKeyUp={this.onKeyUp}
                            />
                        </FormGroup>
                        <QuizObjectTextField
                            trackingValue={
                                this.props.quiz_object.tracking.definition
                            }
                            field="definition"
                            multiline={true}
                            status={this.props.quiz_object.status.get(
                                "definition"
                            )}
                            handleChange={this.props.handleDefinitionChange}
                            value={this.props.quiz_object.definition}
                            focusField={this.focusField}
                            blurField={this.blurField}
                            onKeyUp={this.onKeyUp}
                            label="Definition"
                            maxLength={140}
                        />
                        <br />
                        {this.props.quiz_object.notes.length > 0 ? (
                            <FormGroup>
                                <TextField
                                    id="notes"
                                    multiline={true}
                                    onChange={this.props.handleNotesChange}
                                    value={this.props.quiz_object.notes}
                                    onFocus={() => {
                                        this.focusField("notes");
                                    }}
                                    onBlur={this.blurField}
                                    className="form-control"
                                    label="Notes"
                                />
                            </FormGroup>
                        ) : (
                            <></>
                        )}
                        <FormGroup>
                            <QuizObjectFacts
                                quiz_object={this.props.quiz_object}
                                focusField={this.focusField}
                                blurField={this.blurField}
                            />
                        </FormGroup>
                        <FormGroup>
                            <QuizObjectLists
                                quiz_object={this.props.quiz_object}
                                focusField={this.focusField}
                                blurField={this.blurField}
                            />
                        </FormGroup>
                        <FormGroup>
                            <QuizObjectCardTables
                                card_tables={this.props.quiz_object.card_tables}
                                focusField={this.focusField}
                                blurField={this.blurField}
                            />
                        </FormGroup>
                        <FormGroup>
                            <QuizObjectTables
                                quiz_object={this.props.quiz_object}
                                focusField={this.focusField}
                                blurField={this.blurField}
                            />
                        </FormGroup>
                        <FormGroup>
                            <QuizObjectChunks
                                chunks={this.props.quiz_object.chunks}
                                quiz_object={this.props.quiz_object}
                                focusField={this.focusField}
                                blurField={this.blurField}
                                subjectHashKey={this.props.subjectHashKey}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-lg-3 right-side-bar">{help}</div>
                </div>
            </div>
        );
    }
}

export default observer(FullObjectPane);
